function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// your-tooltip.jsx
import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip, sx, themeGet } from '../..';

// Root

const renderTruncateStyles = truncate => {
  if (truncate) {
    return css(["max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
  }
};
/**
 * Accessible tooltip that can be used as a 1:1 drop-in replacement in Atlassian products.
 *
 * Provides additional functionality like an optional arrow and customizable display timing.
 *
 * To be rendered inside of a <Tooltip.Provider>. To render a customized component, extend the Fuegokit React Tooltip primitive to create your own tooltip.
 *
 * See https://fuegokit.design/react/primitives/tooltip
 */
const AtlasTooltip = ({
  children,
  content,
  open,
  defaultOpen,
  position,
  delay = 300,
  onOpenChange,
  hideArrow = true,
  align,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    delayDuration: delay
  }, /*#__PURE__*/React.createElement(Tooltip.Trigger, {
    asChild: true
  }, children), /*#__PURE__*/React.createElement(StyledTooltipContent, _extends({
    side: position,
    align: align
  }, props), /*#__PURE__*/React.createElement(React.Fragment, null, content), !hideArrow && /*#__PURE__*/React.createElement(StyledTooltipArrow, {
    width: 11,
    height: 5
  })));
};
AtlasTooltip.displayName = "AtlasTooltip";
const StyledTooltipContent = styled(Tooltip.Content).withConfig({
  displayName: "AtlasTooltip__StyledTooltipContent",
  componentId: "sc-1hqkdpk-0"
})(["box-sizing:border-box;max-width:240px;padding:2px 6px;top:0;left:0;border-radius:", ";font-size:", ";line-height:1.3;overflow-wrap:break-word;word-wrap:break-word;background-color:", ";color:", ";", " ", ""], themeGet('radii.1'), themeGet('fontSizes.1'), themeGet('colors.background.neutral.bold.default'), themeGet('colors.text.inverse'), p => renderTruncateStyles(Boolean(p.truncate)), sx);
const StyledTooltipArrow = styled(Tooltip.Arrow).withConfig({
  displayName: "AtlasTooltip__StyledTooltipArrow",
  componentId: "sc-1hqkdpk-1"
})(["fill:", ";", ""], themeGet('colors.background.neutral.bold.default'), sx);
AtlasTooltip.displayName = 'AtlasTooltip';
export default AtlasTooltip;